import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/discount', request)
}

async function post(request) {
    return await postMethod('/api/discount', request)
}

async function put(discountId, request) {
    return await putMethod(`/api/discount/${discountId}`, request)
}

export {post, get, put}
